import styled, { css } from "styled-components";

import { DESKTOP_BREAKPOINT } from "../AppShell/styles";

/* Tag and CTA share the first row; the pitch text (and optional description) sits below (see `$compact`) */
export const Container = styled.button<{ $compact?: boolean }>`
  display: grid;
  grid-template-areas:
    "tag cta"
    "text text";
  grid-template-columns: auto 1fr;
  gap: 0.75rem;
  align-items: center;
  width: 100%;
  padding: 1.25rem;
  text-align: left;
  background:
    radial-gradient(120% 140% at 0% 0%, rgba(87, 242, 139, 0.18) 0%, rgba(87, 242, 139, 0) 60%),
    var(--color-neutral-dark);
  border-radius: 1rem;
  transition: filter 0.15s;

  &:hover {
    filter: brightness(1.1);
  }

  .tag {
    grid-area: tag;
  }

  .text {
    display: flex;
    flex-direction: column;
    grid-area: text;
    gap: 0.25rem;
  }

  p {
    font-family: Inter, sans-serif;
    font-size: 0.9375rem;
    font-weight: 800;
    line-height: 1.25rem;
    color: var(--color-neutral-white);
  }

  .description {
    font-family: Inter, sans-serif;
    font-size: 0.8125rem;
    line-height: 1.125rem;
    color: var(--color-neutral-150);
  }

  .cta {
    grid-area: cta;
    justify-self: end;
    font-family: Inter, sans-serif;
    font-size: 0.8125rem;
    font-weight: 700;
    color: var(--color-brand-plus);
  }

  /* Compact: less padding, title and description side by side; on desktop tag, text and CTA share one row */
  ${props =>
    props.$compact &&
    css`
      gap: 0.5rem 1rem;
      padding: 0.75rem 1rem;
      border-radius: 12px;

      .text {
        flex-flow: row wrap;
        gap: 0 0.5rem;
        align-items: baseline;
      }

      /* Smaller pitch, so it fits one line next to the tag and the CTA */
      p {
        font-size: 0.8125rem;
        line-height: 1.125rem;
      }

      .description {
        font-size: 0.75rem;
      }

      @media (min-width: ${DESKTOP_BREAKPOINT}) {
        grid-template-areas: "tag text cta";
        grid-template-columns: auto minmax(0, 1fr) auto;
      }
    `}
`;
